import { verifyIfIsInMaintenance } from 'src/util/verifyIsInMaintenance'
import api from '../api'

export interface BannerDefault {
  id?: number
  banner: BannerCarousel
}

export interface BannerCarousel {
  id: number
  titulo: string
  clicks: number
  imagem_desktop: ImagemDesktop
  imagem_mobile: ImagemMobile
  link: LinkBanner
}

export interface ImagemDesktop {
  id: number
  chave: string
  bucket: string
  url: string
  link?: string
}

export interface ImagemMobile {
  id: number
  chave: string
  bucket: string
  url: string
  link?: string
}

export interface LinkBanner {
  id: number
  tipo_chave: string
  parametros: Parametros
}

export interface Parametros {
  url: string
  target: string
  query_strings?: string
}

export interface BannerResponse {
  data: BannerDefault[]
}

export const getBannersSliderHome = async () => {
  try {
    const { data } = await api.get<BannerDefault[]>(
      `/canais/banners-areas/slider-home`
    )
    return data
  } catch (error: any) {
    return verifyIfIsInMaintenance(error)
  }
}

export const getBannersSliderLivelo =
  async (): Promise<BannerResponse | void> => {
    try {
      const { data } = await api.get<BannerResponse>(
        `/canais/banners-areas/slider-livelo`
      )
      return data
    } catch (error: any) {
      verifyIfIsInMaintenance(error)
    }
  }

export const registerClick = async (bannerId: string) => {
  try {
    const { data } = await api.patch<void>(`/canais/banners/${bannerId}/clicks`)
    return data
  } catch (error) {
    console.error(error)
  }
}
